import { GlobalConfiguration } from "./configurationProvider";

const accountNameStandardised = (data) =>
  data
    ?.toLowerCase()
    ?.split(" ")
    ?.map(
      (word) =>
        word.charAt(GlobalConfiguration?.lengthCheckZero).toUpperCase() +
        word.slice(GlobalConfiguration?.lengthCheckOne),
    )
    ?.join(" ");

export default accountNameStandardised;
